import React from "react";
import type { TEmailChannel } from "../helpers/email-channel-types-helper";

interface IEmailChannelInfoFieldProps {
  channel: TEmailChannel;
}

const EmailChannelInfoField: React.FC<IEmailChannelInfoFieldProps> = ({
  channel,
}) => <strong className="email-channel-address">{channel.username}</strong>;

export default EmailChannelInfoField;
